import { makeStyles } from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import Grid from "@material-ui/core/Grid"
import Hidden from "@material-ui/core/Hidden"
import React, { Fragment } from "react"
import Typography from "@material-ui/core/Typography"
import NoImage from "src/assets/no-image.jpg"
import CommaPrice from "src/features/Utils/CommaPrice"

const useStyles = makeStyles((theme) => ({
  image: {
    display: "block",
    maxWidth: "70px",
    maxHeight: "100px",
    width: "auto",
    height: "auto",
    [theme.breakpoints.up("md")]: {
      maxWidth: "50px",
      maxHeight: "50px",
    },
  },
}))

function DiscountPreview(props) {
  const classes = useStyles()
  const { image, name, amount, total } = props
  const imageURI = image || NoImage
  return (
    <Fragment>
      <Box my={1}>
        <Hidden mdUp>
          <Grid container spacing={2}>
            <Grid item xs={4} sm={3}>
              <img
                alt={`${name}-pic`}
                src={imageURI}
                className={classes.image}
              />
            </Grid>
            <Grid item xs={8} sm={9}>
              <Typography variant="body2" gutterBottom>
                {name}
              </Typography>
              <Typography variant="body2" gutterBottom>
                {amount} test
              </Typography>
              <Box display="flex" alignItems="center">
                <Box flexGrow={1}>
                  <Typography variant="body2">test</Typography>
                </Box>
                <Box textAlign="right">
                  <Typography variant="body2" align="right" color="primary">
                    {CommaPrice(total)}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Hidden>
        <Hidden smDown>
          <Grid container alignItems="center" spacing={2}>
            <Grid item md={2}>
              <img
                alt={`${name}-pic`}
                src={imageURI}
                className={classes.image}
              />
            </Grid>
            <Grid item md={6}>
              <Typography component="span" variant="body2">
                {name}
              </Typography>
            </Grid>
            <Grid item md={2}>
              <Typography component="span" variant="body2">
                {amount} set(s)
              </Typography>
            </Grid>
            <Grid item md={2}>
              <Typography
                component="span"
                display="block"
                variant="body2"
                align="right"
                color="primary"
              >
                {CommaPrice(total)}
              </Typography>
            </Grid>
          </Grid>
        </Hidden>
      </Box>
    </Fragment>
  )
}

DiscountPreview.defaultProps = {
  image: NoImage,
  name: "",
  amount: 0,
  total: 0,
}

export default DiscountPreview
